import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import CodeContent from './CodeContent';
import BasicTable from './Tabla';
import TablaDocs from './TablaDocs';

function TablaDoc(
  Descripcion,
 Detalles
) {
return { Descripcion,Detalles };
}

const Boleta = () => {
  const [t] = useTranslation('global');
  
  const rows = [
  TablaDoc(t('content.boleta.ejemplo1'),  '/content/EjemploBoletas/EMISION POR VENTA INTERNA CON OPERACION GRAVADA.json'),
  TablaDoc(t('content.boleta.ejemplo2'),  '/content/EjemploBoletas/EMISION POR VENTA INTERNA CON DESCUENTO POR ITEM GRAVADO.json'),
  TablaDoc(t('content.boleta.ejemplo3'),  '/content/EjemploBoletas/EMISION POR VENTA INTERNA CON OTROS CARGOS CON OPERACIÓN GRAVADA.json'),
  TablaDoc(t('content.boleta.ejemplo4'),  '/content/EjemploBoletas/EMISION POR VENTA INTERNA CON ICBPER GRAVADO.json'),
  TablaDoc(t('content.boleta.ejemplo5'),  '/content/EjemploBoletas/EMISION POR VENTA INTERNA CON OPERACIÓN GRATUITA.json'),
  TablaDoc(t('content.boleta.ejemplo6'),  '/content/EjemploBoletas/EMISION POR VENTA INTERNA CON OPERACIÓN EXONERADA.json'),
  TablaDoc(t('content.boleta.ejemplo7'),  '/content/EjemploBoletas/EMISION POR VENTA INTERNA CON DESCUENTO POR ITEM EXONERADO.json'),
  TablaDoc(t('content.boleta.ejemplo8'),  '/content/EjemploBoletas/EMISION POR VENTA INTERNA CON EXONERADO GRATUITO.json'),
  TablaDoc(t('content.boleta.ejemplo9'),  '/content/EjemploBoletas/EMISION POR VENTA INTERNA CON OPERACIÓN INAFECTO.json'),
  
];
  return (
    <div id='boleta'>
      <Divider sx={{ height: '70px' } } />
      <Typography variant="h3" id="boletaTitulo" gutterBottom>
        {t('content.boleta.titulo')}
      </Typography>
      <Typography variant="h5" gutterBottom id="facturaTitulo">
        {t('content.boleta.subtituloJson')}
      </Typography>
      <Typography variant="body1" id="boletaTitulo" gutterBottom>
        {t('content.boleta.descripcion')}
      </Typography>
      {/*<br id={"boletaDescripcion"}/>*/}
      <TablaDocs rows={rows} />
    </div>
  );
}
export default Boleta